import axios, { AxiosResponse } from 'axios'
import {
  FormularioDtoEmpresaCreate,
  FormularioDtoUnidadeCreate,
  FormularioEmpresaListQueryResponse,
  FormularioEmpresaView,
  VinculosQueryResponse,
} from './_models'
import { ID } from '../../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const FORMULARIOS_VINCULOS_URL = `${API_URL}/formularios/vinculos`
const FORMULARIOS_VINCULOS_ESPECIALIDADE_URL = `${API_URL}/formularios/vinculos/especialidade`

/**
 * Vincula formulário à empresa
 * @param data FormularioDtoEmpresaCreate
 * @returns FormularioEmpresaView
 */
export const bindFormularioToEmpresasWithEspecialidade = (
  data: FormularioDtoEmpresaCreate
): Promise<FormularioEmpresaView> => {
  return axios
    .post(`${FORMULARIOS_VINCULOS_URL}`, data)
    .then((d: AxiosResponse<FormularioEmpresaView>) => d.data)
}

/**
 * Vincula formulário à unidade
 * @param empresaId Identificador da empresa
 * @param data FormularioDtoUnidadeCreate
 * @returns FormularioEmpresaView
 */
export const bindFormularioToUnidadesWithEspecialidade = (
  empresaId: number,
  data: FormularioDtoUnidadeCreate
): Promise<FormularioEmpresaView> => {
  return axios
    .post(`${FORMULARIOS_VINCULOS_URL}/${empresaId}`, data)
    .then((d: AxiosResponse<FormularioEmpresaView>) => d.data)
}

/**
 * Busca todos os vínculos do formulário
 * @param query string
 * @param formularioId Identificador do formulário
 * @returns FormularioEmpresaListQueryResponse
 */
export const getEspecialidadeVinculosByFormularioId = (
  query: string,
  formularioId: number
): Promise<FormularioEmpresaListQueryResponse> => {
  return axios
    .get(`${FORMULARIOS_VINCULOS_URL}/${formularioId}?${query}`)
    .then((resp: AxiosResponse<FormularioEmpresaListQueryResponse>) => resp.data)
}

export const getVinculosGroupByEspecialidade = (
  formId: ID,
  query: string
): Promise<VinculosQueryResponse> => {
  return axios
    .get(`${FORMULARIOS_VINCULOS_ESPECIALIDADE_URL}/${formId}?${query}`)
    .then((d: AxiosResponse<VinculosQueryResponse>) => d.data)
}

/* 
O DELETE recebe parametros id_empresa, id_especialidade e idUnidade. Nesse caso, remove apenas um vínculo.

Passando apenas o parâmetro especialidade, irá remover o vinculo dessa especialidade para todas as empresas.

Passando apenas o parâmetro empresa, irá remover o vínculo para todas as especialidades da empresa.

Se não passar nenhum dos parâmetros, irá remover todos os vínculos do questionário.

*/

/**
 * Desvincula formulário
 * @param formId ID Formulário
 * @param especialidadeId ID Especialidade
 * @param empresaId ID Empresa
 * @param unidadeId ID Unidade
 * @returns void
 */
export const deleteEspecialidadeVinculo = (
  formId: number,
  especialidadeId?: number,
  empresaId?: number,
  unidadeId?: number
): Promise<VinculosQueryResponse> => {
  let query = ''

  if (especialidadeId) {
    query += `idEspecialidade=${especialidadeId}`
  }

  if (empresaId) {
    query += (query ? '&' : '') + `idEmpresa=${empresaId}`
  }
  if (unidadeId) {
    query += (query ? '&' : '') + `idUnidade=${unidadeId}`
  }

  return axios
    .delete(`${FORMULARIOS_VINCULOS_URL}/${formId}?${query}`)
    .then((d: AxiosResponse<VinculosQueryResponse>) => d.data)
}
